import React from 'react'
import cx from 'classnames'
import { User } from '@components/UI'

import ParticipantMedia, {
  useIsParticipantVideoEnabled
} from './ParticipantMedia'
import { useRecordingMainParticipant } from '../../hooks'

const RecordingMainParticipant = ({ minimized }) => {
  const { _id, online, image } = useRecordingMainParticipant()
  const { enabled: isVideoEnabled, media } = useIsParticipantVideoEnabled(_id)

  return (
    <div
      className={cx('gp-Media-mainParticipantInfo', {
        'is-videoOff': online && !isVideoEnabled
      })}
    >
      <div className='gp-Media-mainParticipantInfo-video'>
        {online && isVideoEnabled && <ParticipantMedia media={media} />}
        {online && !isVideoEnabled && (
          <User
            name={name}
            img={image}
            hideName
            size={minimized ? 'larger' : 'gigantic'}
          />
        )}
      </div>
    </div>
  )
}
export default RecordingMainParticipant
